<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      salvando: {
        type: Boolean,
        default: false,
      },
      quantidade: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
      texto() {
        if (this.quantidade > 1) {
          return `Deseja liberar o pagamento dos ${this.quantidade} rateios selecionados?`;
        }

        return 'Deseja liberar este pagamento?';
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           :backdrop="!salvando">
      <div slot="modal-header" class="modal-header hide"></div>

      <div class="swal2-icon swal2-question" style="display: block;">?</div>

      <h3 class="text-center">{{ texto }}</h3>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" :disabled="salvando" @click="$emit('liberar')">
          <i class="fa fa-check"></i> Liberar
        </button>
        <button type="button" class="btn btn-default" :disabled="salvando" @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pagamento/componentes/ModalConfirmarLiberacao.vue